import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';
const OperationsTabContent = () => {
	const intl = useIntl();

	const gwp9473JSWAnchorUpdates = checkFeatureFlagGate(featureFlags.gwp9473JSWAnchorUpdates);

	const operationsHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.operations.header',
			defaultMessage: 'Operations processes made easy with Jira',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w4g3m6wrfl232cm6kx12p83t1sg1odlm.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira backlog',
			}),
		},
	};

	const gwp9473JSWAnchorUpdatesHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.operations.header',
			defaultMessage: 'Conquer complex workflows',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mbx11md7br33n86667to5e4q87x8dfl.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira board view',
			}),
		},
	};

	return (
		<PaidHeroTabPanelTemplate
			{...(gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : operationsHeroProps)}
		/>
	);
};

export default OperationsTabContent;
